<template>
  <div class="home" ref="Home">
    <swiper
      :slides-per-view="1"
      :pagination="bannerOptions.pagination"
      :autoplay="bannerOptions.autoplay"
      :loop="bannerOptions.loop"
      ref="banner"
      class="banner"
    >
      <swiper-slide>
        <img src="@/assets/banner1.png" alt="">
      </swiper-slide>
      <swiper-slide>
        <img src="@/assets/banner2.png" alt="">
      </swiper-slide>
      <div class="pagination"></div>
    </swiper>
    <div class="project" ref="Project">
      <img src="@/assets/page_project.png" alt="">
    </div>
    <div class="services" ref="Services">
      <img src="@/assets/page_services.png" alt="">
    </div>
    <div class="about" ref="About">
      <img src="@/assets/page_about.png" alt="">
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs, getCurrentInstance } from 'vue'

import SwiperCore, { Scrollbar, Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/swiper.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import 'swiper/components/pagination/pagination.scss'

SwiperCore.use([Scrollbar, Pagination, Autoplay])

export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    routerItems: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    routerName: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup (props, { emit }) {
    const instance = getCurrentInstance()
    const state = reactive({
      bannerOptions: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.banner .pagination',
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active',
          clickable: true
        }
      }
    })

    const scrollToTop = () => {
      let routerName = null
      const top = window.pageYOffset
      props.routerItems.forEach(item => {
        if (top >= instance.refs[item.value].offsetTop - 80) {
          routerName = item.value
        }
      })
      emit('getNavChange', {
        value: routerName,
        type: 'scroll'
      })
    }

    onMounted(() => {
      // window.addEventListener('scroll', scrollToTop, true)
    })

    return {
      ...toRefs(state)
    }
  },
  watch: {
    routerName (val) {
      const sTop = this.$refs[val].offsetTop
      window.scrollTo({
        top: sTop - 80,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  position: relative;
  img {
    display: block;
    width: 100%;
    height: calc(100vh - 80px);
    object-fit: cover;
    object-position: center bottom;
  }
  .pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
}
::v-deep .banner .pagination .bullet {
  width: 100px;
  height: 5px;
  background-color: #ffffff;
  margin: 0 5px;
  cursor: pointer;
}
::v-deep .banner .pagination .bullet.bullet-active {
  background-color: #ea0e0e;
}
.project {
  width: 100%;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
.services {
  width: 100%;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
.about {
  width: 100%;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
